import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '@app/services/authentication/authentication.service';
import { ToastrService } from 'ngx-toastr';
import { AutharizedEndPointService } from '@app/services/base-service/autharized-endpoint.service';
import {AppComponent} from '@app/app.component';
@Component({
    selector: 'pn-login',
    templateUrl: './login.component.html'
})

export class LoginComponent implements OnInit {

    userName: string;
    password: string;
    constructor(
        private router: Router,
        private toastr: ToastrService,
        private authenticationService: AuthenticationService, public myapp: AppComponent
       
    ) {  }

    ngOnInit() {    
            
             this.myapp.ChangeColourForAcquirer(true);
    }

    // login() {
    //     this.authenticationService.login(this.userName, this.password)
    //         .subscribe(
    //             data => {
    //                 const tempdata = JSON.parse(JSON.stringify(data));
    //                 localStorage.setItem('currentUser', JSON.stringify(tempdata));
    //                 localStorage.setItem('ChangePasswordValidation', JSON.stringify(tempdata.ChangePassword));
    //                 const currentUser = AutharizedEndPointService.UserInfo;
    //                 localStorage.setItem('userName', this.userName);
    //                 localStorage.setItem('id', currentUser.EmailAddress);
    //                 localStorage.setItem('Category', currentUser.CategoryTypeId);
    //                 localStorage.setItem('SubCategory', currentUser.SubCategoryTypeId);
    //                 localStorage.setItem('EntityType', currentUser.EntityTypeId);
    //                 localStorage.setItem('EntityId', currentUser.EntityId);
    //                 this.toastr.success('You have successfully logged in', 'Login',
    //                     {
    //                         timeOut: 2000,
    //                     });
    //                 if (tempdata.EntityTypeId == 102)
    //                     this.router.navigate(['/app/merchant/dashboard']);
    //                 else
    //                     this.router.navigate(['/home']);

    //             },
    //             error => {
    //                 if (error.error.error === 'invalid_grant') {
    //                     this.toastr.warning(error.error.error_description, '');
    //                 } else {
    //                     this.toastr.error('There is some issue. Please try later.!', 'Login!');
    //                 }
    //             });
    // }

    login() {
        this.authenticationService.login(this.userName, this.password)
            .subscribe(
                data => {
                    // debugger;
                    const tempdata = JSON.parse(JSON.stringify(data));
                    console.log(tempdata);
                    if (tempdata.IsRedirect) {
                        //window.location.href="http://localhost:2115/IGLPreLogin.aspx/Login";
                        var el = document.createElement('form');
                        var htmlHead = document.createElement('meta');
                        htmlHead.charset = "utf-8";
                        el.setAttribute('method', 'post');
                        el.setAttribute('action', tempdata.RedirectUrl);
                        el.setAttribute('enctype', 'application/x-www-form-urlencoded;charset= utf-8');
                        var user = document.createElement('input');
                        user.value = this.userName;
                        user.name = "txtUserName";
                        var password = document.createElement('input');
                        password.type = 'password';
                        password.value = this.password;
                        password.name = "txtPassword";
                        var __EVENTTARGET = document.createElement('input');
                        __EVENTTARGET.type = 'hidden';
                        __EVENTTARGET.value = "lnkSubmit";
                        
                        __EVENTTARGET.name = "__EVENTTARGET";   
                        el.appendChild(user)
                        el.appendChild(password)
                        el.appendChild(__EVENTTARGET)
                        el.style.display = 'none';
                        document.head.appendChild(htmlHead);
                        document.body.appendChild(el);
                        el.submit();
                    }
                    else {
                        localStorage.setItem('currentUser', JSON.stringify(tempdata));
                        localStorage.setItem('ChangePasswordValidation', JSON.stringify(tempdata.ChangePassword));
                        const currentUser = AutharizedEndPointService.UserInfo;
                        localStorage.setItem('userName', this.userName);
                        localStorage.setItem('id', currentUser.EmailAddress);
                        localStorage.setItem('Category', currentUser.CategoryTypeId);
                        localStorage.setItem('SubCategory', currentUser.SubCategoryTypeId);
                        localStorage.setItem('EntityType', currentUser.EntityTypeId);
                        localStorage.setItem('EntityId', currentUser.EntityId);
                        localStorage.setItem('AcquirerId', currentUser.AcquirerId);
                        this.toastr.success('You have successfully logged in', 'Login',
                            {
                                timeOut: 2000,
                            });
                           
                        this.router.navigate(['/merchant']);
                        
                        
                    }
                },
                error => {
                    if (error.error.error === 'invalid_grant') {
                        this.toastr.warning(error.error.error_description, '');
                    } else {
                        this.toastr.error('There is some issue. Please try later.!', 'Login!');
                    }
                });
    }
}


// WEBPACK FOOTER //
// ./src/app/components/customer-login/login.component.ts